import React from "react";
import {
  Box,
  Chip,
  IconButton,
  Pagination,
  Table,
  TableRow,
  TableHead,
  TableBody,
  TableCell,
} from "@mui/material";
import {
  VisibleContent,
  SkeletonLoadingTable
} from "../../../../components";
import { getExportJobTypeLabel } from "../../../../constants/exportTypes";
import exportStatus from "../../../../constants/exportStatus";
import moment from "moment";
import { getUrlForStaticApi } from "../../../../utils/urlStaticFiles";
import downloadFile from "../../../../utils/downloadFile";
import CloudDownloadIcon from "../../../../icons/CloudDownloadIcon";

const TableCustom = ({ page, items, totalPages, totalCount = 0, isLoading, onChangePage, documentTypeNamesById = {} }) => {
  return (
    <Box>
      <Table>
        <TableHead>
          <TableRow>
            <TableCell>Тип задачи</TableCell>
            <TableCell>Статус</TableCell>
            <TableCell>Дата создания</TableCell>
            <TableCell>Дата завершения</TableCell>
            <TableCell sx={{ width: 48 }} />
          </TableRow>
        </TableHead>
        <TableBody>
          <VisibleContent visible={!isLoading}>
            {items.map((item) => (
              <ItemRow
                key={`ItemRow-${item.id}`}
                item={item}
                documentTypeNamesById={documentTypeNamesById}
              />
            ))}
          </VisibleContent>
          <VisibleContent visible={isLoading}>
            <SkeletonLoadingTable countRows={10} countColumns={5} />
          </VisibleContent>
        </TableBody>
      </Table>

      <Box sx={{ display: "flex", alignItems: "center", justifyContent: "space-between", py: 2 }}>
        <span style={{ fontSize: 14, color: "#71717A" }}>Найдено {totalCount.toLocaleString("ru-RU")} записей</span>
        <Box sx={{ display: "flex", alignItems: "center", gap: 3 }}>
          {totalPages > 1 && (
            <Box sx={{ display: "flex", alignItems: "center", gap: 1, fontSize: 14, color: "#71717A" }}>
              <span>Страница {page} из {totalPages}</span>
              <Pagination count={totalPages} page={page} onChange={(e, p) => onChangePage(p)} size="small" />
            </Box>
          )}
        </Box>
      </Box>
    </Box>
  )
}

const ItemRow = ({ item, documentTypeNamesById }) => {
  const statusItem = exportStatus?.[item.status];

  const handleDownload = (e) => {
    e.stopPropagation();
    downloadFile(getUrlForStaticApi(item.url), item.url?.split("/").pop());
  };

  const formatDate = (date) => {
    if (!date || date === '0001-01-01T00:00:00Z') return '—';
    return moment(date).format('DD.MM.YYYY HH:mm');
  };

  return (
    <TableRow hover>
      <TableCell>{getExportJobTypeLabel(item, documentTypeNamesById)}</TableCell>
      <TableCell>
        {statusItem && (
          <Chip
            label={statusItem.label}
            size="small"
            sx={{
              fontWeight: 600,
              fontSize: 12,
              color: statusItem.colorTx,
              backgroundColor: statusItem.colorBg,
            }}
          />
        )}
      </TableCell>
      <TableCell sx={{ whiteSpace: "nowrap" }}>{formatDate(item.created)}</TableCell>
      <TableCell sx={{ whiteSpace: "nowrap" }}>{formatDate(item.completed)}</TableCell>
      <TableCell>
        {item.url && (
          <IconButton size="small" sx={{ color: "#A1A1AA", p: 0.5 }} onClick={handleDownload}>
            <CloudDownloadIcon />
          </IconButton>
        )}
      </TableCell>
    </TableRow>
  )
}

export default TableCustom
